/** Display public server guidance; never interpret an unknown error as a source defect. */
export function generationFailureMessage(error: string | null | undefined): string {
  const text = error || '';
  const start = text.indexOf('원인:');
  if (start >= 0 && text.includes('안내:')) return text.slice(start);
  // Job-level messages the worker already writes for users (no raw exception text).
  if (/^(일부 항목이 처리되지 않았습니다|\d+개 항목이 재시도 한도 초과로 실패했습니다)/.test(text.trim())) {
    return text.trim();
  }
  if (/포인트.*부족|insufficient.credit/i.test(text)) {
    return '원인: 출제에 필요한 포인트가 부족합니다.\n안내: 포인트 잔액을 확인한 뒤 다시 출제해 주세요.';
  }
  if (/timeout|timed out|deadline|시간.*초과/i.test(text)) {
    return '원인: 제한 시간 안에 출제를 완료하지 못했습니다.\n안내: 잠시 후 다시 시도해 주세요.';
  }
  return '원인: 출제를 완료하지 못했으며, 정확한 원인을 확인할 수 없습니다.\n안내: 다시 시도해 주세요. 반복되면 문제 유형과 지문 번호를 함께 문의해 주세요.';
}
